import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const get = async (url, params, fallback) => {
    try {
        const r = await axios.get(`${API_BASE_URL}${url}`, { params });
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const post = async (url, payload, fallback) => {
    try {
        const r = await axios.post(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

const put = async (url, payload, fallback) => {
    try {
        const r = await axios.put(`${API_BASE_URL}${url}`, payload);
        return r.data;
    } catch (error) {
        if (error.response?.data) throw error.response.data;
        throw error.message || fallback;
    }
};

// ── Lookups ──────────────────────────────────────────────────────────────────

export const getCostCenterTypes = () => get('/Accounts/GetCostCenterTypes', {}, 'Failed to fetch cost centre types');
export const getItCodesLookup = () => get('/Accounts/GetITCodes', {}, 'Failed to fetch IT codes');
export const getTypeOfTaxes = () => get('/Accounts/GetTypeOfTaxes', {}, 'Failed to fetch type of taxes');
export const getNatureOfTaxes = () => get('/Accounts/GetNatureOfTaxes', {}, 'Failed to fetch nature of taxes');
export const getAllDcaForSubDca = () => get('/Accounts/GetAllDcaForSubDca', {}, 'Failed to fetch account heads');
export const getApprovalStatusDCA = (CheckType, ROID) =>
    get('/Accounts/GetapprstatusDCA', { CheckType, ROID }, 'Failed to fetch allowed actions');
export const getApprovedDcaById = (DcaId, Dcatypeid) =>
    get('/Accounts/GetApprovedDcabyId', { DcaId, Dcatypeid }, 'Failed to fetch account head details');

// ── Grid ─────────────────────────────────────────────────────────────────────

export const getAllDCAForDCASubDCA = () => get('/Accounts/GetAllDCAForDCASubDCA', {}, 'Failed to fetch account heads');

// ── Save / Edit — DCA (General / Tax) ────────────────────────────────────────

export const saveNewDCA = (payload) => post('/Accounts/SaveNewDCA', payload, 'Failed to save account head');
export const updateDCA = (payload) => put('/Accounts/UpdateDCA', payload, 'Failed to update account head');

// ── Save — Sub DCA ────────────────────────────────────────────────────────────

export const saveNewSubDCA = (payload) => post('/Accounts/SaveNewSubDCA', payload, 'Failed to save sub account head');
